module.exports = "/_next/static/images/EnableUserData-9dd96473f7df728988071625896bd835.webp";